import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient.ts'
import {raise} from '@utilities/helpers.ts'
import {httpGetPatient} from './patients.http'
import {PatientExtended, PatientSmall} from '../types'
import {ResponseType} from '@/types'

type PatientResponse<T extends ResponseType> = T extends 'extended' ? PatientExtended : PatientSmall

export const useGetPatient = <T extends ResponseType>({
    patientId,
    responseType,
    options
}: {
    patientId?: string
    responseType?: T
    options?: Omit<UseQueryOptions<PatientResponse<T>>, 'queryKey' | 'queryFn'>
}) =>
    useQuery({
        queryKey: [QUERY_KEYS.PATIENTS, patientId, responseType],
        queryFn: () =>
            httpGetPatient({
                urlParams: {patientId: patientId ?? raise('patientId is nullish')},
                params: {responseType: responseType ?? 'extended'}
            }),
        ...options
    })
